import Link from "next/link";
import { useTranslations } from "next-intl";
import { useState } from "react";

import myaccount from "~/components/common/myaccount.module.scss";
import { useAuthContext } from "~/contexts/auth";
import { useConfiguration } from "~/contexts/configuration";
import useSubscriptions from "~/hooks/use-subscriptions";
import appRoutes from "~/utils/app-routes";
import loyaltyUtils from "~/utils/loyalty-utils";

import Button from "../common/button";
import LoyaltyProgress from "./loyalty/loyalty-progress";
import styles from "./loyalty-card.module.scss";
import QRCodeDialog from "./qrcode-dialog";

export default function LoyaltyCard() {
  const t = useTranslations();
  const { user } = useAuthContext();
  const { configuration } = useConfiguration();
  const { userSubscriptions } = useSubscriptions();
  const [qrCodeDialogOpen, setQRCodeDialogOpen] = useState<boolean>(false);

  const isUserSubscribedToLoyalty = loyaltyUtils.getLoyaltySubscription(userSubscriptions)?.Status === 2;

  const tierName = loyaltyUtils.getUserLoyaltyTierName(user, configuration);

  const loyaltySubscription = loyaltyUtils.getLoyaltySubscription(userSubscriptions);

  return (
    <>
      <div className={myaccount.myaccountCard}>
        <div className={myaccount.myaccountCardHeader}>
          <h2>{t("generic.myLoaltyTitle")}</h2>
          {isUserSubscribedToLoyalty ? (
            <Button lookAsLink onClick={() => setQRCodeDialogOpen(true)}>
              {t("generic.dashboard.showQRCode")}
            </Button>
          ) : null}
        </div>
        <div className={myaccount.myaccountCardContent}>
          {isUserSubscribedToLoyalty ? (
            <>
              <div className={styles.progress}>
                <LoyaltyProgress />
                <div className={styles.pointsLevelWrapper}>
                  <p>{tierName || t("loyalty.basicLevel")}</p>
                  <p>
                    {t("generic.loyaltyPoints", {
                      points: loyaltySubscription?.Subscription?.LoyaltyBalance?.Points ?? "",
                    })}
                  </p>
                </div>
              </div>
              <div className={styles.footer}>
                {/* TODO Hidden as we're not receiving information about user current tier, so it's not possible do get the number of remaining points to the next tier */}
                {/* <p>
                  {t.rich("generic.missingPointsForNextLevel", {
                    points: prefigureDiscountsData?.[0]?.ConditionsResults?.[0]?.LoyaltyPointsMissing,
                    pointsContainer: <span>{points}</span>,
                  })}
                </p> */}
                <Link href={appRoutes.LOYALTY}>{t("generic.discoverMore")}</Link>
              </div>
            </>
          ) : (
            <p className={styles.noLoyalty}>
              {t.rich("generic.notEnrolledToLoyalty", {
                br: (chunks) => <br />,
                strong: (chunks) => <span className={styles.strong}>{chunks}</span>,
                myAccountLink: (chunks) => (
                  <Link className={styles.link} href={appRoutes.MYACCOUNT_SETTINGS}>
                    {chunks}
                  </Link>
                ),
              })}
            </p>
          )}
        </div>
      </div>
      <QRCodeDialog isOpen={qrCodeDialogOpen} onClose={() => setQRCodeDialogOpen(false)} />
    </>
  );
}
